module.exports = __webpack_public_path__ + "static/img/achiev_icon.9014403e.png";